<div class="container-fluid">
    <div class="dashboard-tabs"
        *ngIf="!isBlankState && !authService.user?.isAdmin">
        <pmd-tab-group class="card pmd-card position-relative sticky-tab mb-0">
            <div class="position-absolute-right mb-3 mb-md-0 date-dropdown date_and_select_group">
                <div class="selection-dropdown-group">
                    <form class="form-inline"
                        [formGroup]="durationFilterForm"
                        autocomplete="off">
                        <div class="d-flex align-items-center filter_dropdown-dashboard">
                            <pmd-textfield-outline class="drop_box">
                                <div class="d-flex align-items-center">
                                    <ng-select [searchable]="false"
                                        labelForId="dashboard-filter-by"
                                        [markFirst]="true"
                                        [items]="dateFilterItem"
                                        formControlName="dateFilter"
                                        bindLabel="name"
                                        bindValue="value"
                                        appearance="outline"
                                        [clearable]="false"
                                        class="pmd-select pmd-select-outline w-100"
                                        name="searchFilter"
                                        ng-click="active!= ng-select-opened">
                                        <ng-template ng-option-tmp
                                            let-dateFilter="item">
                                            <div class="pmd-checkbox-option">
                                                {{ dateFilter?.name}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </pmd-textfield-outline>
                            <pmd-input-group-outline class="khr-input-group-outline-icon input-group-sm khr-icon-r">
                                <pmd-textfield-outline>
                                    <div class="duration-dropdown"
                                        pmdDropdown
                                        [positionFixed]="true"
                                        (onShown)="onDurationPickerOpen()"
                                        [autoClose]="true"
                                        pmdPlacement="bottom-end">
                                        <pmd-input-group-outline pmd-input-group-icon>
                                            <pmd-textfield pmd-textfield-outline>
                                                <input pmdTextField
                                                    pmdDropdownToggle
                                                    id="datePicker-dashboard"
                                                    class="form-control form-control-sm dropdown-toggle"
                                                    formControlName="duration"
                                                    aria-label="datePicker-dashboard"
                                                    aria-describedby="datePicker-dashboard"
                                                    readonly />
                                                <i *ngIf="!isCurrentQuarterSelected()"
                                                    (click)="getDuration('clear');setDuration()"
                                                    class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 cursor-pointer clear-input">
                                                    close
                                                </i>
                                            </pmd-textfield>
                                        </pmd-input-group-outline>
                                        <div class="dropdown-menu date-mobile"
                                            *pmdDropdownMenu>
                                            <div>
                                                <div class="customrange-datepicker">
                                                    <pmd-daterangepicker-inline (bsValueChange)="durationChange($event)"
                                                        *ngIf="dateShow"
                                                        [bsConfig]="{ showWeekNumbers: false, maxDateRange: 89, todayHighlight: true}"
                                                        [bsValue]="duration"
                                                        [maxDate]="today">
                                                        <div
                                                            class="pmd-datepicker-predefined-btns pmd-datepicker-custom-range">
                                                            <h6 class="dropdown-header">Date selection</h6>
                                                            <a class="dropdown-item"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('thisWeek')"
                                                                (mouseleave)="getDuration('reset')"
                                                                (click)="setDuration()">
                                                                This Week
                                                            </a>
                                                            <a class="dropdown-item"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('lastWeek')"
                                                                (mouseleave)="getDuration('reset')"
                                                                (click)="setDuration()">
                                                                Last Week
                                                            </a>
                                                            <a class="dropdown-item"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('fortnight')"
                                                                (mouseleave)="getDuration('reset')"
                                                                (click)="setDuration()">
                                                                Last 15 Days
                                                            </a>
                                                            <a class="dropdown-item"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('MTD')"
                                                                (mouseleave)="getDuration('reset')"
                                                                (click)="setDuration()">
                                                                Month Till Date
                                                            </a>
                                                            <a class="dropdown-item"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('YTD')"
                                                                (mouseleave)="getDuration('reset')"
                                                                (click)="setDuration()">
                                                                Year Till Date
                                                            </a>
                                                            <a class="dropdown-item active"
                                                                href="javascript:void(0);"
                                                                (mouseenter)="getDuration('today')"
                                                                (mouseleave)="getDuration('clear')">
                                                                Custom Range
                                                            </a>
                                                        </div>
                                                    </pmd-daterangepicker-inline>
                                                    <div class="pmd-datepicker-buttons">
                                                        <span class="ml-auto me-4">
                                                            <span class="ml-auto me-2 fromDateLable">
                                                                {{ duration[0].toLocaleDateString("en-US",
                                                                appGlobals.dateFormat) }}
                                                            </span>
                                                            <span class="ml-auto me-2"> to </span>
                                                            <span class="ml-auto me-2 toDateLable">
                                                                {{ duration[1].toLocaleDateString("en-US",
                                                                appGlobals.dateFormat) }}
                                                            </span>
                                                        </span>
                                                        <button pmd-btn
                                                            (click)="getDuration('clear');setDuration()"
                                                            pmdRipple
                                                            color="light"
                                                            class="me-2 btn-light-gray">
                                                            Cancel
                                                        </button>
                                                        <button pmd-btn-raised
                                                            (click)="setDuration()"
                                                            pmdRipple
                                                            color="secondary">
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </pmd-textfield-outline>
                                <pmd-input-group-text class="pmd-input-icon-absolute border-0 bg-white">
                                    <i class="material-icons pmd-icon-xs "
                                        color="secondary">calendar_month</i>
                                </pmd-input-group-text>
                            </pmd-input-group-outline>
                        </div>
                    </form>
                </div>
            </div>
            <pmd-tab label="Overview"
                id="tab-overview">
                <app-overview [duration]="durationFilter"
                    [isTabActive]="activeTabId==='overview'">
                </app-overview>
            </pmd-tab>
            <pmd-tab label="Items"
                id="tab-item">
                <app-product [duration]="durationFilter"
                    [isTabActive]="activeTabId==='item'">
                </app-product>
            </pmd-tab>
            <pmd-tab label="Supplier"
                id="tab-supplier">
                <app-supplier [duration]="durationFilter"
                    [isTabActive]="activeTabId==='supplier'">
                </app-supplier>
            </pmd-tab>
            <!-- <pmd-tab label="GST Amount"
                id="tab-gst">
                <app-gst [duration]="durationFilter"
                    *ngIf="activeTabId==='gst'">
                </app-gst>
            </pmd-tab> -->
        </pmd-tab-group>
    </div>
    <pmd-card *ngIf="isBlankState"
        class="mb-0">
        <app-blank-dashboard></app-blank-dashboard>
    </pmd-card>
</div>